<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Flow Tests</div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button mat-button color="lightGreen" (click)="createTest()">New Test</button>
  </div>
</div>

<div class="flow-tests">
  <div class="container flow-tests-container" *ngIf="!isLoading; else loadingTpl">
    <div class="container-header no-bottom-border">
      <div class="text">Tests</div>
    </div>
    <div class="container-content">
      <table mat-table [dataSource]="dataSource" class="mat-table">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row">{{ row.id }}</td>
        </ng-container>

        <ng-container matColumnDef="flow">
          <th mat-header-cell *matHeaderCellDef>Flow</th>
          <td mat-cell *matCellDef="let row">{{ flowName(row) }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-pill status-{{ row.status }}">{{ row.status }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let row">{{ row.created_at | date: 'short' }}</td>
        </ng-container>

        <ng-container matColumnDef="completed_at">
          <th mat-header-cell *matHeaderCellDef>Completed</th>
          <td mat-cell *matCellDef="let row">
            {{ row.completed_at ? (row.completed_at | date: 'short') : '—' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row" class="options-cell">
            <button
              class="icon-btn"
              mat-button
              (click)="viewTest(row)"
              matTooltip="View Test"
            >
              <svg-icon
                src="assets/svg/view.svg"
                [svgStyle]="{
                  'width.px': '16',
                  'height.px': '16'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <button
              class="icon-btn"
              mat-button
              (click)="deleteTest(row)"
              matTooltip="Delete Test"
            >
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <div class="empty" *ngIf="dataSource.data.length === 0">
        No flow tests yet. Click "New Test" to create one.
      </div>

      <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>

<ng-template #loadingTpl>
  <div class="loading">Loading…</div>
</ng-template>
